import React from 'react';

import AuthForm from '../../components/AuthForm/AuthForm';
import AuthLayout from '../../layout/AuthLayout/AuthLayout';

export default function RegisterScreen() {
	return (
		<AuthLayout>
			<AuthForm />
		</AuthLayout>
	);
}
